import { Component } from "react";
import FieldModal from "../../../../components/modals/fieldModal";
import InputField from "../../../../components/inputs/inputField";
import API from "../../../../utils/API";

class RenamePrinterModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            activePrinterDevices: [],
            options: [],
            selectedPrinterDevice: null,
            selectedPrinterDeviceFriendlyName: props.printer ? props.printer.friendlyName : '',
            requiredFieldsFilled: false,
        }
    }


    renamePrinter = async () => {
        const { orgId, eventId, toggle, checkInAppConfiguration, printer } = this.props;
        const payload = {
            organizationId: orgId,
            eventId: eventId,
            printerDeviceId: printer._id,
            friendlyName: this.state.selectedPrinterDeviceFriendlyName,
        };

        await API().patch(`/patchActivePrinterDevice`, payload).then((res) => {
            if (res.data) {
                let updatedActivePrinterDevices = checkInAppConfiguration.printerDevices || [];
                let updatedPrinterDevice = res.data.printerDevice;
                const existingIndex = updatedActivePrinterDevices.findIndex(device => device._id === updatedPrinterDevice._id);
                if (existingIndex !== -1) {
                    updatedActivePrinterDevices[existingIndex] = updatedPrinterDevice;
                } else {
                    updatedActivePrinterDevices.push(updatedPrinterDevice);
                }
                this.props.updatedActivePrinterDevices(updatedActivePrinterDevices);
                toggle();
            }
        });
    }

    render() {
        const { isOpen, toggle, printer } = this.props;
        const { selectedPrinterDeviceFriendlyName, submitting } = this.state;
        let requiredFieldsFilled = false;
        if (selectedPrinterDeviceFriendlyName.trim() !== '') {
            requiredFieldsFilled = true;
        }

        return <div>
            <FieldModal
                size="medium"
                isOpen={isOpen}
                modalTitle={"Rename Printer"}
                bodyHeaderText={''}
                bodyDescription={''}
                bodyContent={() => {
                    return (
                        <div>
                            <InputField
                                label="Friendly Name"
                                value={selectedPrinterDeviceFriendlyName}
                                onChange={(e) => {
                                    this.setState({ selectedPrinterDeviceFriendlyName: e.target.value });
                                }}
                            />
                        </div>)
                }}
                toggle={toggle}
                actionButtonLabel={!submitting ? 'Add ' : 'Adding...'}
                actionButton={() => this.renamePrinter()}
                actionButtonDisabled={submitting || !requiredFieldsFilled}
            ></FieldModal>
        </div>
    }
}

export default RenamePrinterModal;